// extracted by mini-css-extract-plugin
export default {"buttonDownload":"ButtonDownload_buttonDownload__D9ud0","buttonDownload__text":"ButtonDownload_buttonDownload__text__pkbGX"};